import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/video.av1.mp4")